import React from 'react';
// import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
import {
    Button, Form, FormGroup, Label,
    Col,
    Container, Row, Input, FormText
} from 'reactstrap';

import SelectListComponent from '../utils/selectList';
import DateSelector from '../utils/dateSelector';

const OutstandingAirlinePanel = ({ outstandingAirlines, handleChange, handleSelectChange, handleAddOutstandingAirline, airports, airlines, onSearch, OutstandingFlightStartDate, OutstandingFlightEndDate, OutstandingAirportId, OutstandingAirlineId, OutstandingROE, outstandingErrorMessages }) => {
    return (
        <Form onSubmit={e => e.preventDefault()}>
            <Container>
                <Row>
                    <Col xs="6" sm="3">
                        <FormGroup className={"mb-0 " + (outstandingErrorMessages.OutstandingFlightStartDate ? 'has-danger' : '')}>
                            <Label>Start Date</Label>
                            <DateSelector dayNotAllowed={false} maxDate={new Date()} todayDate={(new Date()).toString()} name="startDate" onValueChange={(event) => handleChange(event, 'OutstandingFlightStartDate')} />
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="3">
                        <FormGroup className={"mb-0 " + (outstandingErrorMessages.OutstandingFlightEndDate ? 'has-danger' : '')}>
                            <Label>End Date</Label>
                            <DateSelector dayNotAllowed={false} maxDate={new Date()} todayDate={(new Date()).toString()} name="endDate" onValueChange={(event) => handleChange(event, 'OutstandingFlightEndDate')} />
                        </FormGroup>
                    </Col>

                    <Col xs="6" sm="3">
                        <FormGroup className={"mb-0 " + (outstandingErrorMessages.OutstandingAirportId ? 'has-danger' : '')}>
                            <Label>Station</Label>
                            <SelectListComponent placeholder={'Select airport...'} data={airports} valueKey='Id' textField='Name' selectValue={OutstandingAirportId} onValueChange={(event) => { handleSelectChange(event, 'OutstandingAirportId') } } />
                            { outstandingErrorMessages.OutstandingAirportId && <FormText color="danger"> {outstandingErrorMessages.OutstandingAirportId }</FormText> }
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="2">
                        <FormGroup className={"mb-0 " + (outstandingErrorMessages.OutstandingAirlineId ? 'has-danger' : '')}>
                            <Label>Airline</Label>
                            <SelectListComponent placeholder={'Select airline...'} data={airlines} valueKey='Id' textField='Name' selectValue={OutstandingAirlineId} onValueChange={(event) => handleSelectChange(event, 'OutstandingAirlineId')} />
                            { outstandingErrorMessages.OutstandingAirlineId && <FormText color="danger"> {outstandingErrorMessages.OutstandingAirlineId }</FormText> }
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="1">
                        <FormGroup className={"mb-0 " + (outstandingErrorMessages.OutstandingROE ? 'has-danger' : '')}>
                            <Label>ROE</Label>
                            <Input type="text" placeholder="Rate of Exchange" value={OutstandingROE} onChange={(event) => handleChange(event.target.value, 'OutstandingROE')}/>
                            { outstandingErrorMessages.OutstandingROE && <FormText color="danger"> {outstandingErrorMessages.OutstandingROE }</FormText> }
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="1">
                        <FormGroup className="mt-2">
                             <Button className="btn-avi-primary" onClick={ handleAddOutstandingAirline}>Add</Button>
                        </FormGroup>
                    </Col>
                </Row>
            </Container>
        </Form>
    )
};
export default OutstandingAirlinePanel;



// WEBPACK FOOTER //
// ./src/views/proforma/outstanding-panel.js